var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001246",
    fillRule: "nonzero",
    d: "M.5 1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1H.5zm2 3a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1h-7zm1 3a.5.5 0 0 1 0-1h5a.5.5 0 0 1 0 1h-5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.37c122b9ac8b720c4dd44b9f480a88dc.svg";
export { ForwardRef as ReactComponent };